(function () {
  if (!window.location.pathname.endsWith('/collections/sanding')) {
    return;
  }

  const grid = document.getElementById('product-grid');
  if (!grid) {
    return;
  }

  const items = grid.querySelectorAll('.grid__item[data-ovs-sand-type]');
  const pagination = document.querySelector('.pagination-wrapper');

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function itemMatchesSandTypes(itemType, types) {
    if (types.length === 0) {
      return true;
    }

    if (types.includes('stick-sponge')) {
      return itemType === 'stick' || itemType === 'sponge' || itemType === 'stick-sponge';
    }

    return types.includes(itemType);
  }

  function selectedTypes() {
    return [...document.querySelectorAll('.ovs-sand-type-input:checked')]
      .map((input) => input.dataset.ovsSandType || '')
      .filter((value) => value !== '');
  }

  function selectedGrits() {
    return [...document.querySelectorAll('.ovs-sand-grit-input:checked')]
      .map((input) => input.dataset.ovsGrit || '')
      .filter((value) => value !== '');
  }

  function itemGrits(item) {
    const raw = item.dataset.ovsSandGrits || '';
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-sand-type-input').forEach((input) => {
      const label = input.closest('.ovs-sand-type-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('.ovs-sand-grit-input').forEach((input) => {
      const label = input.closest('.ovs-sand-grit-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncCheckboxesFromUrl() {
    const types = parseList('ovs_sand_type');
    const grits = parseList('ovs_grit');

    document.querySelectorAll('.ovs-sand-type-input').forEach((input) => {
      const type = input.dataset.ovsSandType || '';
      input.checked = types.includes(type);
    });

    document.querySelectorAll('.ovs-sand-grit-input').forEach((input) => {
      const grit = input.dataset.ovsGrit || '';
      input.checked = grits.includes(grit);
    });

    syncCheckboxLabels();
  }

  function buildUrl(types, grits) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_sand_type');
    url.searchParams.delete('ovs_grit');
    url.searchParams.delete('page');

    if (types.length > 0) {
      url.searchParams.set('ovs_sand_type', types.join(','));
    }

    if (grits.length > 0) {
      url.searchParams.set('ovs_grit', grits.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(types, grits) {
    if (!pagination) {
      return;
    }

    const filtersActive = types.length > 0 || grits.length > 0;
    pagination.hidden = filtersActive;
  }

  function applyFilters(updateHistory) {
    const types = selectedTypes();
    const grits = selectedGrits();
    let visibleCount = 0;

    items.forEach((item) => {
      const itemType = item.dataset.ovsSandType || '';
      const itemGritList = itemGrits(item);
      let show = true;

      if (types.length > 0) {
        show = itemMatchesSandTypes(itemType, types);
      }

      if (show && grits.length > 0) {
        show = itemGritList.length > 0 && grits.some((grit) => itemGritList.includes(grit));
      }

      item.hidden = !show;
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(types, grits);

    if (updateHistory) {
      const url = buildUrl(types, grits);
      window.history.pushState({ ovsSandFilters: true }, '', url.pathname + url.search);
    }
  }

  document.querySelectorAll('.ovs-sand-type-input, .ovs-sand-grit-input').forEach((input) => {
    input.addEventListener('change', () => {
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
